/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
import {Code} from '../../../../components/utils/code';
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "WebSemaphore via Websockets"
    }), "\n", _jsx(_components.p, {
      children: "Websockets provide the simplest way to acquire a resource in\nsituations when a public ip is not an option such as enterprise environments\nwith firewall rules and frontend applications."
    }), "\n", _jsx(_components.h2, {
      children: "Reference implementation"
    }), "\n", _jsxs(_components.p, {
      children: ["A sample implementation is available at\n", _jsx(_components.a, {
        href: "https://github.com/broadmindcloud/websemaphore-examples/tree/main/websockets",
        children: "WebSemaphore examples"
      }), " on github."]
    }), "\n", _jsx(_components.h2, {
      children: "Async wrapper"
    }), "\n", _jsx(_components.p, {
      children: "We provide a convenience async/await wrapper that reduces the effort to a simple async call.\nNote that this approach is only usable where the process that initiated the flow is also the one\nto process the task when the lock is acquired. If your flow is distributed, as in a cloud setup, use either\nthe REST API with callbacks or a custom implementation using websockets."
    }), "\n", _jsx(_components.p, {
      children: "How it works: the wrapper maintains an internal registry of sent messages and pending promises.\nThe promise is resolved once the corresponding message is received signaling lock acquisition\n(or possibly rejection if using the sync version)."
    }), "\n", _jsx(Code, {
      height: "600px",
      value: `
const APIKEY = "ApiKey ...";

import { WebSocket } from "ws";
import { WebSemaphoreWSClientPromise } from "websemaphore";

const manager = WebSemaphoreWebsocketsClientManager({ websockets: WebSocket });

const process = (payload: any) => {
    // do work
    console.log("Processing payload:", payload);
}
const main = async () => {
    const client = await manager.connect(env.APIKEY);

    const { release, payload, status } =
        await webSemaphoreClient.acquire({ semaphoreId: env.SEMAPHORE_ID, sync: false, body: { some: "abstract", data: 10 } });

    // ...
    await process(payload, log);
    // ...
    release();

    await manager.disconnect();
}

main();
`
    }), "\n", _jsx(_components.h2, {
      children: "Raw websockets"
    }), "\n", _jsxs(_components.p, {
      children: ["The ", _jsx(_components.a, {
        href: "https://www.websemaphore.com/docs/v1/api/websockets",
        children: "Websockets section"
      }), "\nof the API guide describes the low-level operations that can be used\ndirectly using any websockets implementation.\nThis is the most flexible approach but requires the developer to work at the websockets level.\nFor a simplified integration see the previous section."]
    }), "\n", _jsx(Code, {
      height: "500px",
      value: `
    const socket = new WebSocket("ws://wsapi.websemaphore.com/v1?token=\`ApiKey%20\${APIKEY}\`")

    socket.addEventListener("open", () => {
        socket.send({ action: "lock.acquire", payload: { ... }})
    })

    socket.addEventListerner("message", (msg) => {
        if (ev.data === "pong") return; // send a raw "ping" string to get a pong, to check the connection is alive
        
        this.emit("message", (ev) => {
            
            doWork()
                .then(() => {
                    this.wsClient.send({
                        action: "lock.release",
                        semaphoreId,
                        channelId,
                    });

            })
        });
    })
`
    }), "\n", _jsxs(_components.p, {
      children: ["As you can see, a naive approach will likely make it very complicated. If you use typescript/javascript,\nthe approach in the previous section in more practical. If you need support for another stack/language ", _jsx(_components.a, {
        href: "/contact",
        children: "contact us"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
